import React, {useState, useEffect, useCallback} from 'react';
import {useParams} from 'react-router'
import '../styling/containerStyles.css'
import VerifyNumber from './verifyNumber'
import VerifyOtp from './verifyOtp'
import CustomerDetails from './customerDetails'
import TransactionDetails from './transactionDetails'
import BankDetails from './bankDetails'
import Success from './successTransaction'
import Footer from '../components/footer'
import CircularProgress from '@material-ui/core/CircularProgress'
import Payouts from '../container/paytmPayout'
import PreviousBankDetails from '../container/previousBankDetails';
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import ErrorMessage from './errorMessage';
import { Typography } from '@material-ui/core';
import ImageUploadPage from './imageUpload';
import OnfidoPageptr from './onfidoPageptr';

interface MainProps{
  newCoupon?:string;
}

export const Main: React.FC<MainProps> = (props: MainProps) =>{
// export const Main: React.FC = () =>{

    const [phoneNo, setPhoneNo] = useState('')
    const [codeScanStatus, setCodeScanStatus] = useState(true)
    const [codeScanStatusCode, setCodeScanStatusCode] = useState('')
    const [isVerified, setIsVerified] = useState(false) 
    const [isOtpVerified, setIsOtpVerified] = useState(false)
    const [isNewUser, setIsNewUser] = useState(true) 
    const [newUser, setNewUser] = useState(true) 
    const [isProceeded, setIsProceeded] = useState(false)
    const [isSuccess, setIsSuccess] = useState(false)
    const [loading, setLoading] = useState(false)
    const [amount, setAmount] = useState('')
    const [bonusAmount, setBonusAmount] = useState('')
    const [paymentType, setPaymentType] = useState('')
    const [paymentStatus, setPaymentStatus] = useState('')
    const [accNo, setAccNo] = useState('')
    const [ifsc, setIfsc] = useState('')
    const [bankDetailsSet, setBankDetailsSet] = useState(false)
    const [membershipID, setMembershipID] = useState('')
    const [redeemable, setRedeemable] = useState(false)
    const [paymentMessage, setPaymentMessage] = useState('')
    const [msgPh, setMsgPh] = useState('')
    const [bankMsg, setBankMsg] = useState('')
    const [transactions, setTransactions] = useState('')
    const [conversions, setConversions] = useState(['', '', ''])
    const [confirmedPayStatus, setConfirmedPayStatus] = useState(false)
    const [orderID, setOrderID] = useState('')
    const [razorID, setRazorID] = useState('')
    const [canRedeem, setCanRedeem] = useState(true)
    const [couponValid, setInvalidCoupon] = useState(false)
    const [otpMessage, setOtpMessage] = useState('')
    const [failUnbind, setFailUnbind] = useState('')
    const [transactionLoading, setTransactionLoading] = useState(false)
    const [countCheck, setCount] = useState(true)
    const [previousBankDetails, setPreviousBankDetails] = useState('')
    const [previousBankDetailsFlag, setPreviousBankDetailsFlag] = useState(false)
    const [prevBankType, setPreviousBankType] = useState(false)
    const [prevBankUUID, setPreviousBankUUID] = useState(['', ''])
    const [loadingRedeem, setLoadingRedeem] = useState(false)
    const [bonusPoint, setBonusPoint] = useState(['', '', ''])
    const [promoAmount, setPromoAmount] = useState(['', '', '', ''])
    const [promoCode, setPromoCode] = useState('')
    const [promoCodeMessage, setPromoCodeMessage] = useState('')
    const [promoLoader, setPromoLoader] = useState(false)
    const [promoApplied, setPromoApplied] = useState(false)
    const [promoAmt, setPromoAmt] = useState('')
    const [isErr, setIsErr] = useState(false)
    
    // Added for IDFY
    const [getFile, setGetFile] = useState('');
    const [docUploadFlag, setDocUploadFlag] = useState('');
    const [idfyDocData, setIdfyDocData] = useState('');
    const [skipStatus, setSkipStatus] = useState('');
    const [idfyTranStatus, setIdfyTranStatus] = useState('');
    const [docUploadLoading, setDocUploadLoading] = useState(false);
    const [idfyCountCheck, setIdfyCount] = useState(true);
    const [kycMessageVerified, setKycMessageVerified] = useState('');
    const [kycDocStatus, setKycDocStatus] = useState('');
    const [isSelfiePage, setIsSelfiePage] = useState(false);
    const [getSelfie, setSelfieFile] = useState('');
    const [selfieDocStatus, setSelfieDocStatus] = useState('');
    const [isOnfidoPage, setIsOnfidoPage] = useState(false)
    const [RejectKYC, setRejectKYC] = useState(false);
    const [KycStatus, setKycStatus] = useState('');
    const [KycStatusAttempt, setKycStatusAttempt] = useState(0);
    const [validateUser, setValidateUser] = useState(true);
    const [faceLiveMessage, setFaceLiveMessage] = useState('');
    const [loginUserType, setLoginUserType] = useState("");
    // end here
    
    // cwc loyalty limit start form here
    const [transactionCount, setTransactionCount] = useState(0);
    const [cmdiName, setCmdiName] = useState('');
    const [cmdiPhoneNumber, setCmdiPhoneNumber] = useState('');
    // cwc loyalty limit end here 

    let interval : any;

    const HOST = process.env.REACT_APP_HOST; 
    const API = process.env.REACT_APP_API;

    const path = window.location.pathname; //using only for roofsealclassic
    const pathParams = path.split('/') //using only for roofsealclassic
    const isForPtr = pathParams[1].toLowerCase() === 'ptr'
    const product = isForPtr ? pathParams[2].toLowerCase() : pathParams[1].toLowerCase()

    const refresh_error_msg = 'Token is invalid or expired';
    let count = 0; 

    const urlParams = new URLSearchParams(window.location.search);
    const dealerPhone = urlParams.get('dealer');
    
    let hostName = window.location.hostname.split('.')[0]
    let userType = ''

    // When need to run in local
    if(hostName === 'localhost' || hostName === 'cwcir'){
      hostName = 'cwcinstantrewards'
    }

    if(hostName === 'saathirewards'){
      userType = 'FCC'
    }
    else if(hostName === 'cwcinstantrewards'){
      userType = 'CWC'
    }
    else if(hostName === 'paytm-instant-rewards'){
      userType = 'CWC'
    }

    interface ParamTypes {
      couponId: string,
    }

    const couponCode = useParams<ParamTypes>().couponId

    const newCouponCode = props.newCoupon //using only for roofsealclassic
    
    const axios = require('axios').default;

    const resetAll = (couponUnbind: boolean) => {
        
        setIsOtpVerified(false)
        setIsVerified(false)
        setIsProceeded(false)
        setIsSuccess(false)
        setIsNewUser(true)
    }

    const resetWhileLogoutAll = (couponUnbind: boolean) => {
      setIsOtpVerified(true)
      setIsProceeded(false)
  }

    useEffect(() => {      
      const checkInitial = async () => {
        const couponStatus = await checkCode();
        if(dealerPhone && !localStorage.getItem("IS_DEALER_LOGIN") && couponStatus?.resultCode === 0) {
          await getDealerLoginOTP();
        }
        if(localStorage.getItem("IS_DEALER_LOGIN") && !dealerPhone) {
          localStorage.clear();
          window.location.reload();
        }
        if(dealerPhone && !localStorage.getItem('IS_DEALER_LOGIN')) {
          if(localStorage.getItem('phone_number') && localStorage.getItem('phone_number') !== dealerPhone) {
            localStorage.clear();
            window.location.reload();
          }
        }
        if(localStorage.getItem("IS_LOGIN") === "yes") {
          resetWhileLogoutAll(true);
        }
      } 
      
      checkCouponChange();
      checkInitial();
    }, []);

    const checkCouponChange = () => {
      if(dealerPhone && localStorage.getItem("IS_DEALER_LOGIN")) {
        const currentCoupon = product === "roofsealclassic" ? newCouponCode : couponCode;

        if(!localStorage.getItem('coupon')) {
          localStorage.setItem('coupon', currentCoupon || '');
        }
  
        if(localStorage.getItem('coupon') !== currentCoupon) {
          localStorage.removeItem('contractor_phone');
          localStorage.removeItem('IS_LOGIN');
          localStorage.removeItem('x-access-token');
          localStorage.removeItem('x-refresh-token');
          resetAll(true);
          localStorage.setItem('coupon', currentCoupon || '');
        }else {
          localStorage.setItem('coupon', currentCoupon || '');
        }
      }
    }

    const getDealerLoginOTP = () => {
      setLoading(true);
      return axios
      .post(
        `${HOST}${API}login/cwcinstantrewards/login-get-otp/`,
        {
          phone_number: dealerPhone, 
          endusercategory_c: isForPtr ? 'PTR' : 'ALL',
          user_type: 'dealer'
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then((res: any) => {
        setLoading(false);
        setIsVerified(true);
        return res;
      })
      .catch((err: any) => {
        if(err.response.status === 400){
          setIsErr(true);
          handleToUpdateStatus('MEMBERINVALID', err.response.data.message, '-', '-');
        }
        setLoading(false);
        return err;
      });
    }

    const verifyDealerLoginOTP = (OTP: any) => {
      return axios
          .post(
            `${HOST}${API}login/token-access/`, 
            {
              phone_number: dealerPhone,
              otp: OTP,
              app_name: 'paytm'
            },
            {
              headers: {
                'Content-Type': 'application/json',
              }
            }
          )
          .then((res: any) => {
            if(res?.status === 200) {
              setOtpMessage("");
              const headers = res?.headers;
              localStorage.setItem('x-access-token', 'Token ' + headers['x-access-token'])
              localStorage.setItem('x-refresh-token', 'Token ' + headers['x-refresh-token'])
              localStorage.setItem('IS_DEALER_LOGIN', 'yes');
              localStorage.setItem('phone_number', `${dealerPhone}`);
              getDealerInfo();
              setIsVerified(false);
              setIsOtpVerified(false);
            }
            return res;
          })
          .catch((err: any) => {
            setOtpMessage("");
            if(err.response?.data?.message?.otp || err.response?.data?.message?.phone_number) {
              setOtpMessage(err.response.data.message.otp ?? err.response.data.message.phone_number);
            }
            return err;
          });
    };

    const getDealerInfo = async () => {
      return axios
        .get(
          `${HOST}apis/v.1.0/lhccinstantrewards/dealer-info/?phone_number=${dealerPhone}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
          if(res?.data) {
            const { dealername_c, dealerphone_c, message, ...rest } = res.data;
            localStorage.setItem('dealer_name', dealername_c);
            localStorage.setItem('dealer_info', JSON.stringify(rest));
          }
          return res;
        })
        .catch((err: any) => {
          return err;
        });
    }

    const validateUserCmdi = async () => {
      setLoading(true)
      return axios
        .get(
          `${HOST}apis/v.1.0/instantrewards/${membershipID}/validate-user-cmdi-type/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')
            }
          }
        )
        .then(async(res: any) => {
          const data = res.data;
          setLoading(false)          
          setValidateUser(data.is_instantrewards_user)
          if(data.is_instantrewards_user === true) {
            await checKYCStatus();
            await documentIdfyStatus(membershipID, '');
          }
          return res;
        })
        .catch((error: any) => {
          setLoading(false)
          return error
        });
    }

    const checKYCStatus = async () => {
      setLoading(true)
      return axios
        .get(
          `${HOST}apis/v.1.0/haisha-contractor/${localStorage.getItem('IS_DEALER_LOGIN') ? localStorage.getItem('contractor_phone') : localStorage.getItem('phone_number')}/check-kyc-required/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')
            }
          }
        )
        .then((res: any) => {
          const data = res.data;
          setLoading(false)          
          setSkipStatus(data.is_kyc_required)
          setIsOnfidoPage(true);
          return res;
        })
        .catch((error: any) => {
          setLoading(false)
          return error
        });
    }

    const checkCode = async() => {
      setLoading(true)
      return axios
      .post(
        `${HOST}${API}check-coupon-code/`,
        {
          code: product === "roofsealclassic" ? newCouponCode : couponCode,
          user: userType
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then((res: any) => {
        const data = res.data.data
        if(data.resultCode === 0){
          setAmount(data.codePoint)
          if(localStorage.getItem("IS_LOGIN") === "yes") {
            handleToUpdateOTP("");
          }
        }
        else{
          setCodeScanStatusCode(data.resultCode)
          setInvalidCoupon(true)
          setCodeScanStatus(false)
          setIsOtpVerified(false)
          setIsVerified(false)
        }
        setLoading(false)
        return data;
      })
      .catch((err: any) => {
        const amtInvalid = err.response.data;
        if(amtInvalid.amount_invalid === true) {
          handleToUpdateStatus('AMOUNTINVALID', amtInvalid.message, '-', '-')
        }
        if(amtInvalid.user_blocked === true) {
          handleToUpdateStatus('BLOCKUSER', amtInvalid.message, '-', '-')
        }
          setCodeScanStatusCode(amtInvalid.resultCode)
          setCodeScanStatus(false)
          setIsOtpVerified(false)
          setIsVerified(false)
          setLoading(false)
          return err;
      });
    }

    const getOtp = async (arg: any) => {
      setLoading(true)
      return axios
      .post(
        `${HOST}${API}login/cwcinstantrewards/login-get-otp/`,
        {
          phone_number: arg, 
          endusercategory_c: isForPtr ? 'PTR' : 'ALL',
          // app_name: 'paytm', 
          // paytm_user_type: userType
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then((res: any) => {
        setLoading(false)
        return res;
      })
      .catch((err: any) => {
        if(err.response.status === 400){
          setIsErr(true)
          handleToUpdateStatus('MEMBERINVALID', err.response.data.message, '-', '-');
        }
          setLoading(false)
          return err;
      });
    }

    const handleToUpdateNumber= async (arg: any) => {
      if(dealerPhone && !localStorage.getItem('IS_DEALER_LOGIN')) {
        return;
      }
      if(codeScanStatus === true){
        setPhoneNo(arg)
          try {
            const checkCodeResponse = await checkCode()                 
            if(checkCodeResponse.resultCode === 0){
              setAmount(checkCodeResponse.codePoint)
              if(localStorage.getItem("IS_LOGIN") === "yes") {
                // resetWhileLogoutAll(true);
                // redemption();
                handleToUpdateOTP("");
              }
              const fetchResponse = await getOtp(arg);
              if(fetchResponse.status === 200){
                if(localStorage.getItem('IS_DEALER_LOGIN')) {
                  localStorage.setItem('contractor_phone', arg);
                } else {
                  localStorage.setItem('phone_number', arg);
                }
                setIsVerified(true)
              }
              else{
                setMsgPh('Something went wrong')
              }
            }
            else{
              setCodeScanStatusCode(checkCodeResponse.resultCode)
              setInvalidCoupon(true)
              setCodeScanStatus(false)
              setIsOtpVerified(false)
              setIsVerified(false)
            }
            
          } catch (e) {
            setMsgPh('Something went wrong')
          }
        }       
    }
    
    const getTokenPair = (phoneNumber: any, otp: any) => {
        return axios
          .post(
            `${HOST}${API}login/token-access/`, 
            {
              phone_number: phoneNumber,
              otp: otp,
              app_name: 'paytm'
            },
            {
              headers: {
                'Content-Type': 'application/json',
              }
            }
          )
          .then((res: any) => {
            localStorage.setItem('IS_LOGIN', "yes")
            return res;
          })
          .catch((err: any) => {
            return err;
          });
    };

    const redemption = async() =>{ 
      setLoading(true)
      setLoadingRedeem(true)

      let apiPayload:any = {
        phone_number: localStorage.getItem('IS_DEALER_LOGIN') ? localStorage.getItem('contractor_phone') : localStorage.getItem('phone_number'),
        division: userType,
        product: isForPtr ? pathParams[2] : pathParams[1],
        endusercategory_c: isForPtr ? 'PTR' : 'ALL',
        code: product === "roofsealclassic" ? newCouponCode : couponCode,
      }

      if(localStorage.getItem("IS_DEALER_LOGIN")) {
        apiPayload = {
          ...apiPayload, 
          dealer_phone_number: localStorage.getItem('phone_number') || null,
        }
      }

      return axios
          .post(
            `${HOST}${API}check-redeemability/`, 
            apiPayload,
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('x-access-token')
              }
            }
          )
          .then((res: any) => {
            const profession = localStorage.getItem('Profession')
            if(profession){
              // For Future Use
              // if(!isForPtr && profession?.includes('Painter')  && !res.data.data.membership_id){
              //   setIsErr(true)
              //   handleToUpdateStatus('MEMBERINVALID', 'This code is not meant for you.', '-', '-');
              // }
              if(isForPtr && !profession?.includes('Painter')  && !res.data.data.membership_id){
                setIsErr(true)
                handleToUpdateStatus('MEMBERINVALID', 'This code is not meant for you.', '-', '-');
              }
            }
            setLoading(false)
            setLoadingRedeem(false)
            return res;
          })
          .catch((err: any) => {
            const memberValidation = err.response.data;
            if(err.response.status === 400){
              setIsErr(true)
              handleToUpdateStatus('MEMBERINVALID', err.response.data.message, '-', '-');
            }
            if(err.response.status !== 400 && memberValidation.user_can_order === true) {
              handleToUpdateStatus('MEMBERINVALID', memberValidation.message, '-', '-');
            }
            setLoading(false)
            setLoadingRedeem(false)
            return err;
          });
    }

    const refresh_access_token = async (res: any) => {
        return axios
          .post(
            `${HOST}${API}login/token-refresh/`, 
            {
              refresh: localStorage.getItem('x-refresh-token')
            },
            {
              headers: {
                'Content-Type': 'application/json',       
              }
            }
          )
          .then((res: any) => {
              if(res.status === 200){
                localStorage.setItem('x-access-token', 'Token ' + res.data['access'])
              }
              else{
                setMsgPh('something went wrong')
                setIsVerified(false)
              }
            })
          .catch((err: any) => {
            setMsgPh('something went wrong')
            setIsVerified(false)
          });
    }

    const handleToUpdateOTP = async (arg: any) => {
      if(dealerPhone && !localStorage.getItem('IS_DEALER_LOGIN')) {
        verifyDealerLoginOTP(arg);
        return;
      }
      
        if(arg === 'GoBack'){
            setIsVerified(false)
        }
        else {
          if(!localStorage.getItem("IS_LOGIN")){
            setLoading(true)
          
          
          if(newUser === false){
            setIsNewUser(false)
          }
        }          
          try {
            if(localStorage.getItem("IS_LOGIN") === "yes") {
              const redemptionResponse = await redemption() 
                
              const response = redemptionResponse.data.data
              setLoginUserType(response.user_type || "");
              if(response.redeemable === false){
                setPaymentStatus('NOT POSSIBLE')
                setPaymentMessage("You are a " + response.user_type)
                setIsSuccess(true)
                setCanRedeem(false)
              }
              else{
                setIsOtpVerified(true)
                if(response.user_type !== "NEW USER"){
                  setIsNewUser(false)
                  setNewUser(false)
                  setMembershipID(response.membership_id)
                }

                if(response.user_type === "LEAD" || response.user_type === "NEW USER"){
                    setTransactionCount(response.transaction_count || 0)
                    setCmdiName(response.cmdi_name)
                    setCmdiPhoneNumber(response.cmdi_phone_number)
                }

                if(response.redemption_options.POINTS === true){
                  setRedeemable(true)
                }
                const factor = response.conversion
                const bonusFactor = response.bonus
                setBonusPoint([bonusFactor.Wallet, bonusFactor.Bank, bonusFactor.Points, bonusFactor.PtoR])
                setConversions([factor.Wallet, factor.Bank, factor.Points, factor.PtoR])
              }

            }
            else {
            const fetchResponse = await getTokenPair(phoneNo, arg)
            const status = fetchResponse.status
            if(status === 200){
                const headers = fetchResponse.headers
                localStorage.setItem('x-access-token', 'Token ' + headers['x-access-token'])
                localStorage.setItem('x-refresh-token', 'Token ' + headers['x-refresh-token'])

                const redemptionResponse = await redemption() 
                
                const response = redemptionResponse.data.data
                setLoginUserType(response.user_type || "");
                if(response.redeemable === false){
                  setPaymentStatus('NOT POSSIBLE')
                  setPaymentMessage("You are a " + response.user_type)
                  setIsSuccess(true)
                  setCanRedeem(false)
                }
                else{
                  setIsOtpVerified(true)
                  if(response.user_type !== "NEW USER"){
                    setIsNewUser(false)
                    setNewUser(false)
                    setMembershipID(response.membership_id)
                  }
                  if(response.user_type === "LEAD" || response.user_type === "NEW USER"){
                    setTransactionCount(response.transaction_count || 0)
                    setCmdiName(response.cmdi_name)
                    setCmdiPhoneNumber(response.cmdi_phone_number)
                  }

                  if(response.redemption_options.POINTS === true){
                    setRedeemable(true)
                  }
                  const factor = response.conversion
                  const bonusFactor = response.bonus
                  setBonusPoint([bonusFactor.Wallet, bonusFactor.Bank, bonusFactor.Points, bonusFactor.PtoR])
                  setConversions([factor.Wallet, factor.Bank, factor.Points, factor.PtoR])
                }

            }
            else{
              const errMessageOTP = fetchResponse.response.data;
                // setOtpMessage('Invalid OTP')
                setOtpMessage(errMessageOTP.message.otp)
            }
          }
          } catch (e) {
            setIsVerified(false)
            setMsgPh('Something went wrong')
          } 
          setLoading(false)
        }
    };

    const checkPainter = (fn: () => void) => {
      const profession = localStorage.getItem('Profession')
      // For Future Use
      // if((!isForPtr && profession?.includes('Painter'))){
      //   setIsErr(true)
      //   handleToUpdateStatus('MEMBERINVALID', 'This code is not meant for you.', '-', '-');
      //   redemption();
      //   return
      // }
      if((isForPtr && !profession?.includes('Painter'))){
        setIsErr(true)
        handleToUpdateStatus('MEMBERINVALID', 'This code is not meant for you.', '-', '-');
        redemption();
        return
      }

      fn();
    }

    const handleToUpdateAddDetails = (arg: any) => {
        setLoading(true)
        if(arg === 'GoBack'){
            resetAll(true)
        }
        else{
          axios
            .post(
              `${HOST}${API}register-user/`, 
              {
                phone_number: localStorage.getItem('IS_DEALER_LOGIN') ? localStorage.getItem('contractor_phone') : localStorage.getItem('phone_number'),
                name: arg.name,
                profession: arg.profession, 
                pincode: arg.pincode,
                user: userType,
                alternate_mobile_no: arg.alternatePhone
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem('x-access-token')       
                }
              }
            )
            .then((res: any) => {
              localStorage.setItem('Profession', arg.profession)
              checkPainter(() => {
                if(res.data.data.data.resultCode === 0){
                  setMembershipID(res.data.data.data.membershipId)
                  setIsNewUser(false)
                }
                else{
                  setIsVerified(false)
                  setIsOtpVerified(false)
                  setInvalidCoupon(true)
                  setMsgPh('something went wrong')
                }
                if(res.status === 401 && res.messages.message === refresh_error_msg && count === 0){
                  refresh_access_token(res)
                  handleToUpdateAddDetails(arg)
                  count += 1
                }
                setLoading(false)
                redemption()
              })
              })
            .catch((err: any) => {
                count = 0
                setIsVerified(false)
                setIsOtpVerified(false)
                setMsgPh('Something went wrong')
                setLoading(false)
            });
          }
    }

    const handleToUpdateStatus = (arg: any, message:any, orderId: string, id: string) => {
      // setLoading(true)
      // setOrderID(orderId)      
      //   setPaymentMessage(message)
      //   setPaymentStatus(arg)
      //   if(arg === "FAILURE"){
      //   }
      //   setIsSuccess(true)
      //   setLoading(false)
      setTransactionLoading(true)
      setLoading(true)
      setOrderID(orderId)
      setRazorID(id)
      if(arg !== 'RESPONSE_MESSAGE' && arg !== 'AMOUNTINVALID' && arg !== 'BLOCKUSER' && arg !== 'MEMBERINVALID') {
      axios //to get list of transactions
        .get(
          `${HOST}${API}transaction-details/${userType}/${localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo}/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            if(res.status === 200){
              setTransactions(res.data)
              setTransactionLoading(false)
            }
          })
        .catch((err: any) => {
          if(err.status === 401 && err.messages.message === refresh_error_msg){
            refresh_access_token('')
          }
          setTransactionLoading(false)
        });
      }
        setPaymentMessage(message)
        setPaymentStatus(arg)
        if(arg === "FAILURE"){
        }
        setIsSuccess(true)
        setLoading(false)
    }

    const handleToGetPreviousBankDetails = async() => {
      setLoading(true)
      // if(arg !== 'RESPONSE_MESSAGE' && arg !== 'AMOUNTINVALID' && arg !== 'BLOCKUSER' && arg !== 'MEMBERINVALID') {
      axios //to get list of transactions
        .get(
          `${HOST}${API}banking-details/${userType}/${localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo}/`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            if(res.status === 200){
              setPreviousBankDetails(res.data);
              if(res.data.length >0) {
                setPreviousBankDetailsFlag(true);
              }
              setLoading(false)
            }
          })
        .catch((err: any) => {
          setLoading(false)
          if(err.status === 401 && err.messages.message === refresh_error_msg){
            refresh_access_token('')
          }
        });
      // }
    }

    const previouslyAddedBankTransaction = (arg:any, type: any) => {
      setPreviousBankUUID([arg, type]);
      setBankDetailsSet(true);
    }

    const removePreiouslyAddedBanks = async(arg:any) => {
      setLoading(true)
      return axios
          .delete(
            `${HOST}${API}banking-details/`, {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('x-access-token')
              },
              params: {
                user_type: userType,
                bank_uuid: arg
              },
            },
          )
          .then((res: any) => {
            setLoading(false)
            handleToGetPreviousBankDetails();
            return res;
          })
          .catch((err: any) => {
            setLoading(false)
            return err;
          });
    }

    const handleToProceedPayment = async(arg: any, amount:any, type:any, bonusAmount:any, promoAmtVal:any) => {
      if(type !== "AddNew") {
        // This code is commented out for future use
        // await validateUserCmdi();
        await checKYCStatus();
        await documentIdfyStatus(membershipID, '');
      }
      setLoading(true)
      setPreviousBankType(arg)
        if(arg === 'GoBack'){
            if(newUser === false){
              resetAll(true)
            }
            else{
              setIsNewUser(true)
            }
        } 
        // logic to convert credit to inr and points
        else{
          
          setAmount(amount)
          setBonusAmount(bonusAmount)
          setPromoAmt(promoAmtVal)
          setIsProceeded(true)
          if(arg === 'paytm'){
            setPaymentType('paytm')
            setLoading(false)
          }
          else if(arg === 'bankAccount'){
            if(type === "AddNew") {
              setPreviousBankDetailsFlag(false);
              setLoading(false)
            }
            if(type !== "AddNew") {
              await handleToGetPreviousBankDetails();
            }
              setPaymentType('bank')
          }
          else if(arg === 'fccPoints'){
            setPaymentType('points')
            setLoading(false)
          } 
          // checkCode()  //commented for after payment prevent to call check coupon code api 
        }
        // setLoading(false)
    }

    const handleToUpdateBankDetails = (arg: any) => {
        setLoading(true)
        if(arg === 'GoBack'){
            setIsProceeded(false)
        }
        else{ //api to send bank details locally
            
            setAccNo(arg.accNo)
            setIfsc(arg.ifsc)
            axios
            .post(
              `${HOST}${API}banking-details/`, 
              {
                phone_number: localStorage.getItem("IS_LOGIN") === "yes" ? localStorage.getItem("phone_number") : phoneNo, 
                account_number: arg.accNo,
                ifsc_code: arg.ifsc,
                bank_name: arg.bankName === 'Others' ? arg.otherBankName : arg.bankName,
                user_type: userType 
              },
              {
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': localStorage.getItem('x-access-token')       
                }
              }
            )
            .then((res: any) => {
              if(res.data.message === 'Maximum accounts added' || res.data.message === 'IFSC Code invalid' || res.data.message === 'Record with same account number exists' || res.data.message === 'Error occurred while Saving Bank Account Details. Please Enter another bank account number and continue.'){
                setBankMsg(res.data.message)
              }
              else{
                setBankDetailsSet(true)
              }
              setLoading(false)
              })
            .catch((err: any) => {
              if(err.status === 401 && err.messages.message === refresh_error_msg && count === 0){
                refresh_access_token(err)
                handleToUpdateAddDetails(arg)
                count += 1
              }
              else{
                count = 0
                resetAll(true)
                setMsgPh('something went wrong')
              }
              setLoading(false)
            });    
        } 
        // setLoading(false)
    }

  const handleValidateCoupon = (arg: any) => {
    setPromoLoader(true)
    setPromoCode(arg);
    return axios
      .post(
        `${HOST}${API}validate-promo-code/`,
        {
          coupon_code: product === "roofsealclassic" ? newCouponCode : couponCode,
          promo_code: arg,
          user_type: userType,
          membership_no: membershipID
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      )
      .then((res: any) => {
        const data = res.data;
        if (res && res.status === 200) {
          setPromoAmount([data.Wallet, data.Bank, data.Points, data.PtoR]);
          setPromoCodeMessage(data.message);
          setPromoLoader(false)
          setPromoApplied(data.is_applied)
          if(data.is_applied === false) {
            setPromoCode("");
          }
        }
      })
      .catch((err: any) => {
        const error = err.response;
        if (error.status === 400) {
          if(error && error.data && error.data.promo_code) {
            setPromoCodeMessage(error.data.promo_code[0]);
          } else {
            setPromoCodeMessage("Please try after some time");
          }
        } else {
          setPromoCodeMessage("Please try after some time");
        }
        setPromoLoader(false)
        setPromoCode("");
        return err;
      });
  }

    const handleToUpdateSuccess = (arg: any) => {
      if(arg === 'GoBack'){
        resetAll(false)
    }
    let myVar:any;
    if(paymentType === "bank") {
      const timeout = async (i:any) =>{
        // setLoading(true)
        myVar = await new Promise((resolve)=> setTimeout(function(){ 
          // if(i === 6) {
          //   // setPaymentStatus("FAILURE")
          //   clearTimeout(myVar);
          //   return;
          // }
          // else 
          if(localStorage.getItem("tran_status") === "FAILURE") {
            clearTimeout(myVar);
            return;
          }
          else if(localStorage.getItem("tran_status") === "SUCCESS") {
            clearTimeout(myVar);
            return;
          }
          axios
          .post(
            `${HOST}${API}get-transaction-status/`, 
            {
              order_id: orderID,
              payment_type: paymentType,
              userType: userType,
              razor_transaction_id: razorID
            },
            {
              headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('x-access-token')       
              }
            }
          )
          .then((res: any) => {
              let status = res.data.response.status === "processed" || res.data.response.status === "SUCCESS" ? "SUCCESS" : 
              res.data.response.status === "queued" || res.data.response.status === "pending" || res.data.response.status === "processing" || res.data.response.status === "APPROVAL_PENDING" || res.data.response.status === "PENDING" || res.data.response.status === "QUEUED" || res.data.response.status === "RECEIVED" ? "PENDING" :
              "FAILURE";
              let statusMessage = res.data.response.statusMessage
              setFailUnbind(status);
              if(status !== "PENDING"){
                localStorage.setItem("tran_status", status)
                setPaymentStatus(status)
                setPaymentMessage(statusMessage)
                setConfirmedPayStatus(true)
              }
            })
          .catch((err: any) => {
          });
          if(i === 3) {
            clearTimeout(myVar);
            return;
          }
          resolve(i);
        }, 10000*i));
          // setLoading(false)
      }
      if(arg === "PENDING"){
        if(countCheck === true) {
          for(let i=1; i<=3; i++){
            timeout(i)
          }
        }
        setCount(false);
      }
      if(failUnbind === "SUCCESS"){
        return;
      }
      if(failUnbind === "FAILURE"){
        return;
      }
    }
    else {
    const timeout = async (i:any) =>{
      // setLoading(true)
      myVar = await new Promise((resolve)=> setTimeout(function(){ 
        // if(i === 6) {
        //   // setPaymentStatus("FAILURE")
        //   clearTimeout(myVar);
        //   return;
        // }
        // else 
        if(localStorage.getItem("tran_status") === "FAILURE") {
          clearTimeout(myVar);
          return;
        }
        else if(localStorage.getItem("tran_status") === "SUCCESS") {
          clearTimeout(myVar);
          return;
        }
        axios
        .post(
          `${HOST}${API}get-transaction-status/`, 
          {
            order_id: orderID,
            payment_type: paymentType,
            userType: userType
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': localStorage.getItem('x-access-token')       
            }
          }
        )
        .then((res: any) => {
            let status = res.data.response.status
            let statusMessage = res.data.response.statusMessage
            setFailUnbind(status);
            if(status !== "PENDING"){
              localStorage.setItem("tran_status", status)
              setPaymentStatus(status)
              setPaymentMessage(statusMessage)
              setConfirmedPayStatus(true)
            }
          })
        .catch((err: any) => {
        });
        if(i === 3) {
          clearTimeout(myVar);
          return;
        }
        resolve(i);
      }, 10000*i));
        // setLoading(false)
    }
    if(arg === "PENDING"){
      if(countCheck === true) {
        for(let i=1; i<=3; i++){
          timeout(i)
        }
      }
      setCount(false);
    }
    if(failUnbind === "SUCCESS"){
      return;
    }
    if(failUnbind === "FAILURE"){
      return;
    }
  }
}

    const handleLogout = () => {
      setIsVerified(true)
      window.location.reload();
      localStorage.clear();
    }

  // for IDFY
  const getDocFile = (file: any, uploadFlag: any) => {
    setGetFile(file);
    setDocUploadFlag(uploadFlag)
  }

  const getSelfieFile = (file: any) => {
    setSelfieFile(file);
  }

  const uploadDocumentIdfy = async () => {
    setDocUploadLoading(true)
    setLoading(true)
    let formdata = new FormData();
    formdata.append("img", getFile);
    formdata.append("membership_no", membershipID);
    return axios
      .post(
        `${HOST}apis/v.1.0/idfy/check-document/`,
        formdata,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': localStorage.getItem('x-access-token')
          },
        }
      )
      .then(async (res: any) => {
        console.log(res.data, "res")
        const data = res.data;
        setKycDocStatus(data)
        if (data.status === true) {
          setIsSelfiePage(true);
        }
        setDocUploadLoading(false)
        setLoading(false)
        setFaceLiveMessage('')
        return res
      })
      .catch((error: any) => {
        setDocUploadLoading(false)
        setLoading(false)
        setFaceLiveMessage('')
        return error
      });
  }

  const documentIdfyStatus = async (arg: any, timer?: any) => {
  //  This is for future use
    // if (!timer) {
    // if(docUploadLoadingFlag === true) {
    //   setDocUploadLoading(false)
    // } else {
    setDocUploadLoading(true)
    // }
    setLoading(true)
    // }
    return axios
      .get(
        `${HOST}apis/v.1.0/idfy/check-status/?membership_no=${arg}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('x-access-token')
          }
        }
      )
      .then((res: any) => {
        const data = res.data;
        setIdfyDocData(data)
        if (data.status === "Pending") {
          setIdfyTranStatus("Kyc verification is in process, Please try again after sometime!")
          setIsOnfidoPage(true)
          setIsSelfiePage(false);
        } else if (data.status === "Rejected" && (data.attempt === 2 || data.attempt > 2)) {
          setRejectKYC(true);
          clearTimeout(interval);
          setIsOnfidoPage(true)
          setLoading(false);
          setIsSelfiePage(false);
          localStorage.setItem("kyc_status", data.status)
        } else if (data.status === "Rejected" && (data.attempt < 3)) {
          setIdfyTranStatus('Your Kyc is rejected, Please try Again!')
          clearTimeout(interval);
          setLoading(false);
          setIsOnfidoPage(true);
          setIsSelfiePage(false);
          localStorage.setItem("kyc_status", data.status)
        } else if (data.status === "Approved") {
          clearTimeout(interval);
          setIsOnfidoPage(false);
          setIsSelfiePage(false);
          setLoading(false);
          localStorage.setItem("kyc_status", data.status)
        }

        setKycStatus(data.status)
        setKycStatusAttempt(data.attempt)
        setDocUploadLoading(false)
        // setLoading(false)
        return res;
      })
      .catch((error: any) => {
        setDocUploadLoading(false)
        setLoading(false)
        return error
      });
  }

  const faceCompare = async () => {
    localStorage.removeItem("kyc_status");
    setDocUploadLoading(true)
    setLoading(true)
    let formdata = new FormData();
    formdata.append("img", getSelfie);
    formdata.append("membership_no", membershipID);
    return axios
      .post(
        `${HOST}apis/v.1.0/idfy/face-compare-live/`, formdata,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('x-access-token')
          }
        }
      )
      .then(async (res: any) => {
        const data = res.data;
        setDocUploadLoading(false)
        setLoading(false)
        if (data.status === "Rejected") {
          setIsOnfidoPage(true);
          setIsSelfiePage(false);
          await documentIdfyStatus(membershipID);
          return;
        } else if (data.status === "Approved") {
          setIsSelfiePage(false);
          setIsOnfidoPage(false)
        } else if (data.status === "Pending") {
          const docidfyStatus = await documentIdfyStatus(membershipID);
          const idfyData = docidfyStatus.data
          setDocUploadLoading(false)
          setLoading(false)
          // set interval if kyc status is pending
          const timeout = async (i: any) => {
            setLoading(true);
            // let myVar: any;
            interval = await new Promise((resolve) => setTimeout(function () {
              if (localStorage.getItem("kyc_status") === "Rejected") {
                setLoading(false);
                clearTimeout(interval);
                return;
              }
              else if (localStorage.getItem("kyc_status") === "Approved") {
                setLoading(false);
                clearTimeout(interval);
                return;
              }
              documentIdfyStatus(membershipID, "timer");
              if (i === 3) {
                setLoading(false);
                clearTimeout(interval);
                return;
              }
              resolve(i);
            }, 10000 * i));
          }
          if (idfyData.status === "Pending") {
            setLoading(false);
            if (idfyCountCheck === true) {
              for (let i = 1; i <= 3; i++) {
                timeout(i)
              }
            }
            setIdfyCount(false);
          }//end here

          if (idfyData.status === "Approved") {
            setIsOnfidoPage(false);
            setIsSelfiePage(false);
            setKycMessageVerified("Yes")
          }
        }
        // setIsOnfidoPage(false) //added for transaction after idfy
        // ---
        return res;
      })
      .catch(async (error: any) => {
        const errRes = error.response;
        setSelfieDocStatus(errRes.data)
        // Added for face liveness message
        if(errRes.status === 400) {
          if(errRes.data.status === "Rejected") {
            setFaceLiveMessage(errRes.data.message)
          }
        }
        if (errRes.data.status === false) {
          setIsOnfidoPage(true);
          setIsSelfiePage(false);
          await checKYCStatus();
          await documentIdfyStatus(membershipID);
        }
        setDocUploadLoading(false)
        setLoading(false)
        return error
      });
  }
  // end here

        return (
          RejectKYC ?
          <ErrorMessage addClass='app3' />
          :
          localStorage.getItem("error_throw") === "yes" ?
            <ErrorMessage />
              :
            <div className='home popup_logout'>
              
                {
                    loading &&
                    <CircularProgress />
                }

                {
                    !loading && loadingRedeem &&
                    <CircularProgress />
                }

                {localStorage.getItem("IS_LOGIN") === "yes" &&
                <div className="logout_btn_paytm button">
                <button className="logout_btn" onClick={handleLogout}><PowerSettingsNewIcon /> Logout</button>
              </div>
                }

              {/* For future user
              {localStorage.getItem("IS_LOGIN") === "yes" && !loading &&
                isOnfidoPage ?
                skipStatus ?
                  <Typography style={{ color: "red" }}>The kyc is mandatory after 2 transactions!</Typography> :
                  <div className="logout_btn_paytm2 button">
                    <button className="logout_btn" disabled={skipStatus ? true : false} onClick={() => (setIsOnfidoPage(false), setIsSelfiePage(false))}>
                      Skip kyc verification</button>
                  </div>
                :
                null
              } */}

                {
                  couponValid && localStorage.getItem("IS_LOGIN") === "yes" &&
                  <VerifyNumber msgPh={msgPh} scan={codeScanStatus} codeScanStatusCode={codeScanStatusCode} handleToUpdateVerified={handleToUpdateNumber} />
                }
                { 
                    !isVerified && !loading && paymentStatus !== 'AMOUNTINVALID' && paymentStatus !== 'MEMBERINVALID' && paymentStatus !== 'BLOCKUSER' && paymentStatus !== 'RESPONSE_MESSAGE' && 
                    !localStorage.getItem("IS_LOGIN") &&
                    <VerifyNumber msgPh={msgPh} scan={codeScanStatus} codeScanStatusCode={codeScanStatusCode} handleToUpdateVerified={handleToUpdateNumber} />
                }

                {
                    !isOtpVerified && isVerified && !loading && canRedeem && !localStorage.getItem("IS_LOGIN") && !isErr &&
                    <VerifyOtp handleToUpdateOtp={handleToUpdateOTP} msg={otpMessage} />
                }

                {
                    isOtpVerified && !couponValid && isNewUser && !loading && !loadingRedeem && paymentStatus !== 'AMOUNTINVALID' && paymentStatus !== 'MEMBERINVALID' && paymentStatus !== 'BLOCKUSER' && paymentStatus !== 'RESPONSE_MESSAGE' && paymentStatus !== 'NOT POSSIBLE' &&
                    <CustomerDetails division={userType} handleToUpdateAdded={handleToUpdateAddDetails}/>
                }
                
                {
                    !isNewUser && !isProceeded && paymentStatus !== 'NOT POSSIBLE' && isOtpVerified && !couponValid && !loading && 
                    <TransactionDetails conversions={conversions} redeemPoints={redeemable} amount={amount} 
                    userType={userType} handleToProceed={handleToProceedPayment} bonusPoint={bonusPoint} 
                    handleValidateCoupon={handleValidateCoupon} promoAmount={promoAmount} promoCodeMessage={promoCodeMessage}
                    setPromoCodeMessage={setPromoCodeMessage} setPromoAmount={setPromoAmount} setPromoCode={setPromoCode} promoLoader={promoLoader} setPromoLoader={setPromoLoader} promoApplied={promoApplied} setPromoApplied={setPromoApplied} transactionCount={transactionCount}
                    cmdiName={cmdiName} cmdiPhoneNumber={cmdiPhoneNumber} />
                }

                {
                    isProceeded && !isSuccess && paymentType==='paytm' && !loading && !couponValid && !isOnfidoPage &&
                    <Payouts type="wallet" phoneNumber={phoneNo} amount={amount} coupon={product === "roofsealclassic" ? newCouponCode : couponCode} user={userType} 
                    membershipID={membershipID} handleToUpdateStatus={handleToUpdateStatus} prevBankUUID={prevBankUUID} bonusAmount={bonusAmount} promoCode={promoCode} promoAmt={promoAmt}  />
                }

                {
                    isProceeded && !isSuccess && paymentType==='bank' && !loading && !couponValid && !bankDetailsSet && !previousBankDetailsFlag && !isOnfidoPage &&
                    <BankDetails bankMsg={bankMsg} handleToUpdatePayment={handleToUpdateBankDetails}/> 
                }

                {
                    isProceeded && !isSuccess && paymentType==='bank' && !loading && !couponValid && !bankDetailsSet && previousBankDetailsFlag && !isOnfidoPage &&
                    <PreviousBankDetails 
                    handleToProceed={handleToProceedPayment} previousBankDetails={previousBankDetails} amount={amount} 
                    prevBankType={prevBankType} previouslyAddedBankTransaction={previouslyAddedBankTransaction} 
                    removePreiouslyAddedBanks={removePreiouslyAddedBanks} bonusAmount={bonusAmount} promoAmt={promoAmt} />
                }

                {
                    bankDetailsSet && !isSuccess && paymentType==='bank' && !loading && !couponValid && !isOnfidoPage &&
                    <Payouts type="bank" phoneNumber={phoneNo} amount={amount} coupon={product === "roofsealclassic" ? newCouponCode : couponCode} user={userType} 
                    membershipID={membershipID} accNo={accNo} ifsc={ifsc} handleToUpdateStatus={handleToUpdateStatus} prevBankUUID={prevBankUUID} bonusAmount={bonusAmount} promoCode={promoCode} promoAmt={promoAmt} />
                }

                {
                    isProceeded && !isSuccess && paymentType==='points' && !loading && !couponValid && !isOnfidoPage &&
                    <Payouts type="points" user={userType} membershipID={membershipID} coupon={product === "roofsealclassic" ? newCouponCode : couponCode} phoneNumber={phoneNo} 
                    amount={amount}  handleToUpdateStatus={handleToUpdateStatus} prevBankUUID={prevBankUUID} bonusAmount={bonusAmount} promoCode={promoCode} promoAmt={promoAmt} />
                }

                {
                    isSuccess && !confirmedPayStatus && !loading && !couponValid && !isOnfidoPage &&
                    <Success paymentMessage={paymentMessage} transactions={transactions} paymentStatus={paymentStatus} 
                    handleToUpdateTransactionOK={handleToUpdateSuccess} transactionLoading={transactionLoading}
                    transactionCount={transactionCount} userType={loginUserType} cmdiName={cmdiName} cmdiPhoneNumber={cmdiPhoneNumber} />
                }

                {
                    isSuccess && confirmedPayStatus && !loading && !couponValid && !isOnfidoPage &&
                    <Success paymentMessage={paymentMessage} transactions={transactions} paymentStatus={paymentStatus} 
                    handleToUpdateTransactionOK={handleToUpdateSuccess} transactionLoading={transactionLoading}
                    transactionCount={transactionCount} userType={loginUserType} cmdiName={cmdiName} cmdiPhoneNumber={cmdiPhoneNumber} />
                }

                {
                  isOnfidoPage && !isSelfiePage &&
                  !loading && !couponValid && validateUser &&
                  <OnfidoPageptr
                    membershipID={membershipID}
                    uploadDocumentIdfy={uploadDocumentIdfy}
                    docUploadLoading={docUploadLoading}
                    getDocFile={getDocFile}
                    idfyDocData={idfyDocData}
                    idfyTranStatus={idfyTranStatus}
                    kycStatusFlag={KycStatus}
                    KycStatusAttempt={KycStatusAttempt}
                    setKycStatus={setKycStatus}
                    kycDocStatus={kycDocStatus}
                    selfieDocStatus={selfieDocStatus}
                    isKycRequired={Boolean(skipStatus)}
                    setIsOnfidoPage={setIsOnfidoPage}
                  />
                }

                {
                  isSelfiePage && !loading && !couponValid && validateUser &&
                  <ImageUploadPage setIsOnfidoPage={setIsOnfidoPage} membershipID={membershipID}
                    faceCompare={faceCompare} getSelfieFile={getSelfieFile} faceLiveMessage={faceLiveMessage} />
                }

                <Footer />

            </div>             
        )
    }

export default Main